import { render, staticRenderFns } from "./areaListDialog.vue?vue&type=template&id=166c75e6&scoped=true"
import script from "./areaListDialog.vue?vue&type=script&lang=js"
export * from "./areaListDialog.vue?vue&type=script&lang=js"
import style0 from "./areaListDialog.vue?vue&type=style&index=0&id=166c75e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166c75e6",
  null
  
)

export default component.exports